import { render } from "./Image.vue?vue&type=template&id=6ebcc8b8&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=6ebcc8b8&lang=scss&scoped=true"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebcc8b8"]])

export default __exports__